import * as Modules from './module-registry';

function setup(): void {
  Modules.setupAprovals();
  Modules.setupProfile();
}

export {
  setup,
};
